// extracted by mini-css-extract-plugin
module.exports = {"dropdownItems":"style-module__dropdownItems___M5t3G","fadeIn":"style-module__fadeIn___2Dsnp","skillSelect":"style-module__skillSelect___3_Pa4"};